import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { astonVillaData } from '../siteData';

const HomeHero = ({ data }) => {
  return (
    <section className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${data.backgroundImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white text-center">
        <div className="max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center bg-green-600/20 backdrop-blur-sm border border-green-500/30 rounded-full px-6 py-2 mb-6">
            <span className="text-green-400 font-bold text-sm uppercase tracking-wider">{data.badge || '20+ Years of Excellence'}</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black mb-6 leading-tight">
            {data.title}
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 font-medium max-w-3xl mx-auto">
            {data.subtitle}
          </p>

          {/* Aston Villa Partnership Badge */}
          <div className="flex items-center justify-center gap-3 mb-10" data-testid="av-hero-badge">
            <img 
              src={astonVillaData.logo} 
              alt="Aston Villa Foundation" 
              className="h-14 w-14 md:h-16 md:w-16 rounded-lg bg-white/10 backdrop-blur-sm p-1.5 border border-white/20"
            />
            <div className="text-left">
              <p className="text-sm md:text-base font-bold text-white">Official Aston Villa</p>
              <p className="text-sm md:text-base font-bold text-white">Foundation Program</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="#programs">
              <Button 
                size="lg" 
                className="bg-green-600 hover:bg-green-700 text-white font-bold text-lg px-10 py-7 rounded-xl transform hover:scale-105 transition-all duration-200 shadow-2xl"
              >
                {data.ctaButtons[0].text}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </a>
            <Link to="/prices">
              <Button 
                size="lg" 
                variant="outline"
                className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-black font-bold text-lg px-10 py-7 rounded-xl transform hover:scale-105 transition-all duration-200"
              >
                {data.ctaButtons[1].text}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
